import React from 'react'

import clsx from 'clsx'

import Avatars from 'components/Avatars'
import Grid from 'components/Grid'
import LastUpdatedDate from 'components/LastUpdatedDate'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'

import author1 from './assets/author-review.png'
import author2 from './assets/author-review2.png'

import classes from './Authors.module.scss'

const Authors = ({ lastUpdatedDate, className = '' }) => {
  const { addEvent } = useEventContext()
  return (
    <div className={clsx(classes.root, className)}>
      <Grid item xs={12} container>
        <div className={classes.contributors}>
          <Avatars className={classes.avatars} imagesUrl={[author1.src, author2.src]} imageSize={36} />
          <Typography variant="tight-xxs" className={classes.legalText}>
            All user reviews are verified by in-house moderators and provider data by our software research team. &nbsp;
            <Link
              variant="tight-xxs"
              href="https://www.getapp.com/resources/about-getapp-teams/"
              target="_blank"
              {...addEvent({
                name: 'engagement_facet_click',
                engagementComponent: 'author-card',
                engagementDestination: 'go-to_authors-page',
                engagementDetails: 'text-link_learn-more',
              })}
            >
              Learn more
            </Link>
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} className={classes.lastUpdate}>
        <LastUpdatedDate lastUpdatedDate={lastUpdatedDate} />
      </Grid>
    </div>
  )
}
export default Authors
